import { render, staticRenderFns } from "./PartnerPattern.vue?vue&type=template&id=275b9e33&scoped=true&"
import script from "./PartnerPattern.vue?vue&type=script&lang=js&"
export * from "./PartnerPattern.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275b9e33",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/paywall/partner/sections/PartnerPattern.vue
// module id = 1578
// module chunks = 0